import { app } from '../../../../../app';

app.service('ManageSharedNoteModal', modal);

/** @ngInject */
function modal($uibModal) {
    return (note) => $uibModal.open({
        component: 'companySharingCenterSharedNoteManage',
        resolve: {note: () => note},
    }).result
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-notes/manage/manage-shared-note.modal.js